import _ from "lodash";
import client from "lib/apolloClient/client";
import { getStudentGoalsQuery } from "Teacher/routes/StudentGoals/components/GoalList/modules/GoalListQueries";
import { getCommentOfNodeQuery } from "./RightPaneQueries";

export const writeCommentsOfNodeQuery = ({ variables, data }) => {
  client.writeQuery({
    query: getCommentOfNodeQuery,
    variables,
    data: { node: data },
  });
};

export const writeStudentGoalsToCache = ({ studentId, filters, data }) => {
  client.writeQuery({
    query: getStudentGoalsQuery,
    variables: {
      studentId,
      filters,
    },
    data: { node: data },
  });
};

export const getCommentsOfNodeFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getCommentOfNodeQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};
